import extend from './extend'

const config = {
  clientName: 'inventory',
  locale: 'fa',
  auth: {
    // User
    userType: 'inventory',

    // Register
    registerViaUserNameEnabled: false,
    registerViaEmailEnabled: true,
    registerViaPhoneNumberEnabled: true,
    registerViaOtpEnabled: true,
    includeProfileFieldsInRegisterForm: true,

    // Login
    loginViaUserNameEnabled: true,
    loginViaEmailEnabled: true,
    loginViaPhoneNumberEnabled: true,
    loginViaOtpEnabled: true,

    // Reset password
    resetPasswordEnabled: true,

    forbiddenErrorConfigs: [{
      error: 'emailNotConfirmed',
      status: 'emailConfirmed',
      settingsKey: 'requireConfirmedEmail',
      allowKey: 'allowUnconfirmedEmail',
      disallowNavigation: false,
      redirectPath: '/account/confirm-email'
    }, {
      error: 'phoneNumberNotConfirmed',
      status: 'phoneNumberConfirmed',
      settingsKey: 'requireConfirmedPhoneNumber',
      allowKey: 'allowUnconfirmedPhoneNumber',
      disallowNavigation: true,
      redirectPath: '/account/confirm-phone-number'
    }, {
      error: 'inventoryDataNotApproved',
      status: 'inventoryDataApproved',
      disallowNavigation: false,
      redirectPath: '/account/profile/basic-info'
    }]
  },
  files: {
    staticServer: 'static.$DOMAIN',
    thumbsAreEnabled: true,
    thumbServer: 'img.$DOMAIN/unsafe',
    noImageUrl: 'https://$DOMAIN/img/no-image.png',
    watermarkUrl: 'https://$DOMAIN/img/watermark.png'
  },
  rootUserName: 'root',
  apiServer: 'api.$DOMAIN',
  websiteUrl: 'https://$DOMAIN',
  ssl: true,
  homeUrl: '/stocks',
  defaultPageSize: 20,
  defaultCalendar: 'jalali',
  calendars: [
    'jalali',
    'gregorian'
  ],
  map: {
    apiKey: 'AIzaSyCXX-tTOkSs8JwMrk_ptxXhVV4N5RVN-Uc',
    defaultLat: 35.6892,
    defaultLng: 51.3890,
    defaultZoom: 13
  },
  country: {
    id: 1,
    phoneCode: '+98'
  },
  timeZone: 'Asia/Tehran',
  layouts: {
    area1: 'oneArea',
    area2: 'twoAreas',
    area3: 'threeAreas',
    area4: 'fourAreas'
  }
}

extend(config)
export default config
